/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarContact_viewer = {
    readonly isContactSupportEnabled?: boolean | null;
    readonly isMessageCenterEnabled?: boolean | null;
    readonly " $refType": "PdpRespSidebarContact_viewer";
};
export type PdpRespSidebarContact_viewer$data = PdpRespSidebarContact_viewer;
export type PdpRespSidebarContact_viewer$key = {
    readonly " $data"?: PdpRespSidebarContact_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarContact_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isContactSupportEnabled",
          "name": "isEnabledByLocale",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "CONTACT_1STDIBS"
            }
          ],
          "storageKey": "isEnabledByLocale(featureName:\"CONTACT_1STDIBS\")"
        },
        {
          "kind": "ScalarField",
          "alias": "isMessageCenterEnabled",
          "name": "isEnabledByLocale",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "MESSAGE_CENTER"
            }
          ],
          "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
        }
      ]
    }
  ]
};
(node as any).hash = 'a3cc230eb74bfcf461f71363689716b0';
export default node;
